export default __webpack_public_path__ + "static/rough-ae7bbcd04a47b42a0144d5d979e05559.png";